module.exports = __webpack_public_path__ + "static/media/icon-refresh.3fff3286.svg";